import * as React from 'react';
import * as styled from './styled';
import {useFormikContext} from 'formik';
import {TaskObject, TestAnswerBlock} from 'api/task/types';
import Switch from 'components/Switch';
import {Answer} from './components/Answer';
import {PushButton} from '../PushButton';
import {useBlockContext} from '../../../../hooks/useBlockContext';

/**
 * The test content.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Test(): React.ReactElement {
  const {setFieldValue} = useFormikContext<Partial<TaskObject>>();
  const block = useBlockContext();

  // @ts-ignore
  const answers = block?.answers || [] as TestAnswerBlock[];

  // @ts-ignore
  const isSeveral = block?.isSeveral as boolean;

  /**
   * Render several.
   * @return {JSX.Element}
   */
  function renderSeveral(): JSX.Element {
    /**
     * The change event handler.
     * @param {React.ChangeEvent<HTMLInputElement>} event
     * @return {void}
     */
    function handleChange(
      event: React.ChangeEvent<HTMLInputElement>,
    ): void {
      setFieldValue(
        `content.blocks[${block.index}].answers`,
        answers.map((answer: TestAnswerBlock) => ({
          ...answer,
          isTrue: false,
        })),
      );
      setFieldValue(
        `content.blocks[${block.index}].isSeveral`,
        event.target.checked,
      );
    }

    return (
      <styled.Several>
        <Switch
          label="Несколько правильных ответов"
          checked={isSeveral}
          onChange={handleChange}
        />
      </styled.Several>
    );
  }

  /**
   * Render answers.
   * @return {JSX.Element}
   */
  function renderAnswers(): JSX.Element {
    /**
     * Render answer.
     * @param {TestAnswerBlock} answer
     * @param {number} index
     * @return {JSX.Element}
     */
    function renderAnswer(
        answer: TestAnswerBlock,
        index: number,
    ): JSX.Element {
      return (
        <Answer
          key={index}
          index={index}
          {...answer}
        />
      );
    }

    return (
      <styled.Answers>
        {answers.map((answer: TestAnswerBlock, index: number) => (
          renderAnswer(answer, index)
        ))}
      </styled.Answers>
    );
  }

  /**
   * Render push button.
   * @return {JSX.Element}
   */
  function renderPushButton(): JSX.Element {
    /**
     * The click event handler.
     * @return {void}
     */
    function handleClick(): void {
      setFieldValue(
        `content.blocks[${block.index}].answers`,
        [
          ...answers,
          {
            isTrue: false,
            text: '',
          },
        ]
      );
    }

    return (
      <styled.PushButton>
        <PushButton onClick={handleClick}>
          Добавить вариант ответа
        </PushButton>
      </styled.PushButton>
    );
  }

  return (
    <styled.Wrapper>
      {renderSeveral()}
      {renderAnswers()}
      {renderPushButton()}
    </styled.Wrapper>
  );
}
